import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { PAGE } from '../../app.routes';
import { Plan } from '../../core';
import { AnatomicalSideLabelPipe, BaseComponent, BoneTypeLabelPipe, PlanTypeLabelPipe } from '../../shared';


/**
 * Component for header of plan settings page.
 */
@Component({
	selector: 'tsp-plan-header',
	imports: [
		PlanTypeLabelPipe,
		BoneTypeLabelPipe,
		AnatomicalSideLabelPipe
	],
	templateUrl: './plan-header.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlanHeaderComponent extends BaseComponent {

	private readonly router = inject(Router);

	plan = input<Plan>();
	hasPatientLink = input<boolean>(false);


	/**
	 * Navigate to Patient Settings page.
	 */
	goToPatient(): void {
		this.router.navigate([PAGE.PATIENT_SETTINGS], { queryParams: { patientGuid: this.plan()?.patientId } });
	}
}
